<template>
  <div class="main fc ac">
    <img style="width: 260px;margin-top: 30px" src="@/assets/index/文字@2x.png" alt />

    <van-collapse class="mt30" :accordion="true" v-model="activeNames" >
      <van-collapse-item  title-class="red"  label-class="black"  title="概念" name="1">
        <div class="sj">人体器官捐献，是指自愿、无偿提供具有特定生理功能的心脏、肺脏、肝脏、肾脏、胰腺或者小肠等人体器官的全部或者部分用于移植的活动。公民生前表示不同意捐献的，任何组织或个人不得捐献、获取该公民的器官；公民生前未表示不同意捐献，该公民死亡后，其配偶、子女、父母等可以共同决定捐献，决定捐献应当采用书面形式。</div>
      
             </van-collapse-item>
      <van-collapse-item  title-class="red"  title="办理流程" name="2">
        <div>
          <div class="sj ">①通过“中国人体器官捐献”微信公众号进行登记。</div>

          <div class="sj ">②通过“中国人体器官捐献管理中心”网站进行登记（www.codac.org.cn）。</div>

          <div class="sj ">③赴当地红十字会器官捐献管理机构或登记站进行书面登记。</div>
          <div class="sj ">④通过中国人体器官捐献管理中心授权单位或组织进行登记。</div>
          <div class="sj ">所有登记信息都要录入“中国人体器官捐献志愿登记管理系统”</div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return { activeNames: "1" };
  },
  methods: {},
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  // padding: 44px;
  width: 100vw;
  height: 100vh;

  background-image: url("./../../assets/index/bg.png");
  background-size: contain;
}
.active {
  background-color: #fb5358;
  color: white;
}
.black {
  color: black;
}
/deep/ .van-collapse-item__content {
  color: black;
}

/deep/ .van-collapse-item__content {
  color: black;
}
/deep/ .van-collapse-item__content {
  background-color: #fffafa;
}
.red {
  font-weight: bold;
  color: #fb5363;
}
/deep/.van-cell__title{
  font-weight: bold;
}
/deep/ .van-collapse{
width: 100%;
}
</style>